/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoShortcutFilter(): angular.IFilterService {
        const filter = (input: any) => {

            if (!input) {
                return "";
            }

            return input.toString().toUpperCase();
        };
        return filter;
    }


    angular.module("meevo.components.filters")
        .filter("meevoShortcut", meevoShortcutFilter);
}
